import { createFileRoute } from '@tanstack/react-router'
import { WorkDetailPage } from '@/features/work/work-detail-page'
export const Route = createFileRoute('/_console/work/$id')({ component: WorkRoute })
function WorkRoute() { const { id } = Route.useParams(); return <WorkDetailPage key={id} id={id} /> }
